module.exports = __webpack_public_path__ + "static/media/radish.e3eeefe6.svg";